import { createFileRoute } from '@tanstack/react-router'
import EngineeringMetrics from "@/views/engineering-metrics";

export const Route = createFileRoute(
  '/_authenticated/_staff/_with_location_switcher/metrics',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <EngineeringMetrics/>
  )
}
